import { render } from "./TextImage.vue?vue&type=template&id=58bae119"
import script from "./TextImage.vue?vue&type=script&lang=js"
export * from "./TextImage.vue?vue&type=script&lang=js"

import "./TextImage.vue?vue&type=style&index=0&id=58bae119&lang=scss"

import exportComponent from "/Users/Sacha/PhpstormProjects/landgoedmorrenrun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__